module.exports = "<div class=\"box_alert disTbl p_disBlo alL mgt20\"> <div class=disTbr> <div class=\"disTbc P_wid40\"><span class=icon_alert></span></div> <p class=\"disTbc pdl5\"><b>出発地・目的地を指定してください。</b></p> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./web/WEB-INF/js/client/search/templates/hotelListError.template.html
// module id = 71
// module chunks = 2